import { initialize } from 'redux-form';
import { CommanderThunkAction, CommanderThunkDispatch } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { fetchAccountsByIds } from '@mews-commander/legacy-entities/src/actions/accounts';
import { fetchProducts } from '@mews-commander/legacy-entities/src/actions/products';
import { fetchActiveEnterpriseServices } from '@mews-commander/legacy-entities/src/actions/services';
import { fetchRates } from '@mews-commander/legacy-entities/src/ducks/exchangeRates';
import { PRODUCT_SERVICE_FORM_INIT } from '../../actions/actionTypes';
import { PRODUCT_SERVICE_FORM_NAME } from '../../constants';
import { getServiceOrderFormInitialValues } from '../../selectors';

// @ts-expect-error removed universal router RouteLeaf['fetchDependency']
const initializeProductServiceOrderCreatePage = async ({ search: { OwnerId, ServiceId, GuestIds }, dispatch }) => {
    const guestIds = typeof GuestIds === 'string' ? [GuestIds] : (GuestIds as string[] | undefined);
    return loadDataForProductServiceOrderForm(ServiceId, OwnerId, guestIds)(dispatch);
};

export const loadDataForProductServiceOrderForm =
    (serviceId: string, customerId: string, guestIds: string[] = []) =>
    async (dispatch: CommanderThunkDispatch) => {
        const enterpriseId = getCurrentEnterpriseId();

        const fetchActions = [
            dispatch(loadServiceDataForProductServiceOrderForm(serviceId, enterpriseId)),
            dispatch(fetchAccountsByIds({ accountIds: [customerId, ...(guestIds ?? [])] })),
            dispatch(fetchRates({ enterpriseId })),
        ];

        const promise = Promise.all(fetchActions);

        return dispatch(createFetchAction(PRODUCT_SERVICE_FORM_INIT, { promise }));
    };

export const loadServiceDataForProductServiceOrderForm =
    (serviceId: string, enterpriseId?: string): CommanderThunkAction =>
    async (dispatch) => {
        const enterprise = enterpriseId ?? getCurrentEnterpriseId();

        return Promise.all([
            dispatch(
                fetchActiveEnterpriseServices({
                    enterpriseIds: [enterprise],
                    serviceIds: serviceId ? [serviceId] : undefined,
                    extent: {
                        products: true,
                        productCategories: true,
                    },
                })
            ),
            serviceId &&
                dispatch(
                    fetchProducts({
                        enterpriseIds: [enterprise],
                        serviceIds: [serviceId],
                    })
                ),
        ]);
    };

export const initializeProductServiceOrderForm =
    (serviceId: string, customerId: string): CommanderThunkAction =>
    (dispatch, getState, { appClockService }) =>
        dispatch(
            initialize(
                PRODUCT_SERVICE_FORM_NAME,
                getServiceOrderFormInitialValues(getState(), { serviceId, customerId, appClockService })
            )
        );

export default initializeProductServiceOrderCreatePage;
